export default __webpack_public_path__ + "static/media/signup.2dbcce77.svg";